import React from "react";
import styles from "./FAQ.module.css";

const FAQ = ({ title, serviceCards }) => {
  return (
    <div className={styles.faqContainer}>
      <div className={styles.secondQuestContainer}>
        <h1 className={styles.Question}>{title}</h1>
        <div className={styles.secondQuestion}>
          {serviceCards.map((card, index) => (
            <div key={index} className={styles.serviceCard}>
              <strong className={styles.header}>{card.header}</strong>
              <span>{card.content}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;
